export enum UserRole {
    Unspecified,
    Technician,
    GeneralOffice,
    Admin,
    Owner,
}

export enum Supplier {
    Dan = 1,
    Adam,
    Charlie,
    Benjamin,
}

export interface ProductPackage {
    PackageId: number;
    PackageName: string;
}

export interface Product {
    ProductID: number;
    ProductName: string;
    Supplier: Supplier;
    CategoryID: number;
    MadeIn: string;
    QuantityPerUnit: string;
    UnitPrice: number;
    UnitsInStock: number;
    UnitsOnOrder: Date;
    Discontinued: boolean;
    AvailableFor?: UserRole;
    Package?: ProductPackage;
}
